import { styled, css } from "../../styles";

export const WorkflowListContainer = styled("div", {
  display: "flex",
  position: "relative",
  flexDirection: "column",
});

export const PageTitleContainer = styled("div", {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: "12px",
});

export const WorflowsTableContainer = styled("div", {
  marginTop: "$4",

  height: "calc(100vh - 300px)",
  maxHeight: "800px",

  position: "relative",
});

export const AddWorkflowButton = styled("div", {
  width: "fit-content",
  height: "26px",
  padding: "5px 11px",

  borderRadius: "12px",
  backgroundColor: "$black",

  color: "$white",
  textAlign: "center",
  fontFamily: "$openSans",
  fontSize: "12px",
  fontWeight: "500",
  lineHeight: "16px",

  whiteSpace: "nowrap",
  cursor: "pointer",

  "&:hover": {
    backgroundColor: "$charcoal",
  },
});

/**
 * EN-5191: the hospital select and the add button used to be absolutely positioned against
 * different ancestors, held apart by `right: 110` — the width of "Add workflow" in English.
 * "Workflow toevoegen" is wider, so the two overlapped. They now share one right-aligned flex
 * row, which needs no measurement of either.
 */
export const WorkflowListActions = styled("div", {
  display: "flex",
  gap: "$3",
  alignItems: "center",
  justifyContent: "flex-end",

  position: "absolute",
  right: "0",
  top: "-32px",
});

export const PMPHospitalGroupSelect = styled("div", {
  width: "fit-content",
});

// CSS

export const HospitalGroupSelectCss = css({
  width: "fit-content !important",
  maxWidth: "200px !important",
  minWidth: "100px !important",
  fontFamily: "$openSans !important",

  // Passing a className replaces SelectDropdown's own css, which is what pins the antd root to
  // the box height. Without it the root stays at antd's 32px around a 26px box drawn at its top,
  // and the row's centre alignment pushed "Add workflow" 3px below the select.
  "&.ant-select": {
    height: "26px !important",
  },

  ".ant-select-selector": {
    borderRadius: "12px !important",
    border: "1.5px $gray-70 solid !important",
    height: "26px !important",
  },

  ".ant-select-arrow": {
    top: "50% !important",
    insetInlineEnd: "6px !important",
  },

  ".ant-select-selection-item": {
    paddingInlineEnd: "26px !important",
    fontSize: "12px !important",
    fontWeight: "500 !important",
    color: "$gray-80 !important",
  },

  ".ant-select-selection-placeholder": {
    paddingInlineEnd: "20px !important",
    paddingInlineStart: "6px !important",
    fontSize: "12px !important",
    fontWeight: "500 !important",
    color: "$gray-80 !important",
  },
});
